var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HqDrawer",
    {
      ref: "drawer",
      attrs: { title: "审核记录", visible: _vm.showVissible, size: "70%" },
      on: {
        "update:visible": function($event) {
          _vm.showVissible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "drawer-body" }, [
        _c(
          "div",
          { staticClass: "goods-table-wrapper" },
          [
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: { width: "100%", "margin-bottom": "24px" },
                attrs: {
                  border: "",
                  stripe: "",
                  size: "mini",
                  "element-loading-text": "拼命加载中",
                  "header-cell-style": { background: "#e5f2ff" },
                  sortable: "",
                  "highlight-current-row": "",
                  "header-cell-class-name": "normal-table-header",
                  data: _vm.tableData,
                  "row-key": function(row) {
                    return row.orderId
                  }
                }
              },
              [
                _vm._l(_vm.columns, function(item) {
                  return [
                    item.prop === "createTime"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            "show-overflow-tooltip": true,
                            label: item.label,
                            "min-width": "160px"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("formatDate")(
                                            row.createTime,
                                            "YYYY-MM-DD HH:mm:ss"
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      : item.prop === "status"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            "show-overflow-tooltip": true,
                            label: item.label,
                            "min-width": "120px"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          scope.row.status == 5
                                            ? "发起审批"
                                            : scope.row.status == 1
                                            ? "审批通过"
                                            : scope.row.status == 7
                                            ? "审批通过"
                                            : scope.row.status == 2
                                            ? "审批拒绝"
                                            : scope.row.status == 3
                                            ? "审批撤销"
                                            : ""
                                        ) +
                                        " "
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      : item.prop === "submitId"
                      ? _c("el-table-column", {
                          key: item.prop,
                          attrs: {
                            "show-overflow-tooltip": true,
                            label: item.label,
                            "min-width": "100px"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    row.submitId === ""
                                      ? _c("span", [_vm._v("- -")])
                                      : _c("span", [
                                          _vm._v(_vm._s(row.submitId))
                                        ])
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      : _c("el-table-column", {
                          key: item.label,
                          attrs: {
                            "show-overflow-tooltip": true,
                            label: item.label,
                            prop: item.prop,
                            fixed: item.fixed,
                            "min-width": item.width || "200px"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    ["remark"].includes(item.prop)
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("empty")(
                                                row[item.prop],
                                                "- -"
                                              )
                                            )
                                          )
                                        ])
                                      : _c("span", [
                                          _vm._v(_vm._s(row[item.prop]))
                                        ])
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                  ]
                })
              ],
              2
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [_c("el-button", { on: { click: _vm.onCancel } }, [_vm._v("返回")])],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }